import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Admin auth is carried by an httpOnly cookie (set by POST /api/auth/login).
// We use withCredentials so the cookie travels on every request — no JWT in localStorage.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatPrice = (amount, currency = "USD") => {
  const symbols = { USD: "$", EUR: "€", ILS: "₪" };
  const symbol = symbols[currency] || currency + " ";
  return `${symbol}${Number(amount).toFixed(0)}`;
};
